import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.catalogItemCart'

export default defineMessages({
  addToRequest: {
    id: `${scope}.addToRequest`,
    defaultMessage: 'Add {quantity} × {title} to my request',
  },
})
